import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, CardMedia, Modal, Button } from '@mui/material';

const programs = [
  {
    title: 'En Línea',
    image: '/images/programa_en_linea.jpg',
    description: `Es un programa informativo que se emite desde La Paz – Bolivia, mediante chukutaradio.com a nivel internacional y en La Paz Bolivia se cuenta con emisoras en señal abierta para comodidad de nuestros oyentes.

EN LÍNEA es una Revista informativa que contiene: Noticias nacionales, Economía y negocios, Sociedad, Salud, Deportes, Educación, Información meteorológica, Tráfico local y Noticias internacionales.

EN LÍNEA tiene como objetivo principal informar al público nacional e internacional sobre hechos de actualidad.`,
    features: [
      'Objetividad: Presenta la información de manera imparcial, sin opiniones personales del locutor.',
      'Veracidad: Se basa en hechos reales, comprobables y contrastados con fuentes confiables. Entrevista en vivo o grabada con un experto.',
      'Claridad y concisión: La información se presenta de forma clara y breve, adecuada al tiempo limitado del formato radial.',
      'Actualización constante: Se enfoca en noticias recientes, muchas veces en tiempo real, especialmente en boletines.',
      'Estructura definida: Suele seguir un orden: titulares, desarrollo de las noticias y cierre o resumen.',
      'Lenguaje accesible: Utiliza un lenguaje sencillo para que cualquier oyente comprenda la información.',
      'Variedad temática: Cubre diferentes secciones como política, economía, deportes, cultura, internacionales, etc.',
      'Uso de recursos sonoros: Incluye efectos de sonido, entrevistas, reportajes grabados, cuñas y música para dinamizar el contenido.',
      'Interacción con la audiencia: Puede permitir llamadas, mensajes o redes sociales para conocer la opinión del público.',
    ],
  },
  {
    title: 'Solo Nostalgias',
    image: '/images/solo_nostalgias.jpg',
    description: `Creo que todos hemos sentido un escalofrío raro y a la vez genial al escuchar alguna canción o melodía del pasado, sobre todo de la infancia. Es algo indescriptible, pero también una de las mejores cosas de la vida.

Así, el discurso radiofónico de la nostalgia es, además de un tema de sensibilidades urbanas y no urbanas, un asunto que actualiza las modalidades y el discurso del sentir en un tiempo ajeno a su creación y contexto original.

En febrero de 1990 nace “SOLO NOSTALGIAS”, donde el único argumento válido es el recuerdo: el diálogo entre generaciones, remontando momentos familiares vividos.

Desde el 2005 se introduce la cumbia nacional como parte del programa de los sábados, con grupos como California, Los Graduados, Cristal, Trigal… Esta música toca lo más profundo del sentir familiar, siendo un puente entre los mayores y nuevas generaciones.`,
    features: [
      'Evoca música del recuerdo desde los años 70 hasta hoy.',
      'Da prioridad a artistas nacionales como Grillo, Luz de América, Signos, Mandril, Four Star.',
      'Incluye grupos extranjeros como Iracundos, Rabito, Ángeles Negros.',
      'El oyente participa con solicitudes musicales y recuerdos.',
      'Se programan entrevistas con artistas para conocer su historia y actualidad.',
    ],
  },
  {
    title: 'Alta Expresión',
    image: '/images/alta_expresion.jpg',
    description: `Bolivia atesora el más rico potencial y puro folklore nativo de Sudamérica. La música popular trae la herencia legada por antiguas culturas que habitaron, es decir, conserva hondas raíces autóctonas.

Como su historia de mezclas, mestizajes y sincretismos, la música en Bolivia es terriblemente diversa. Cada región tiene su propio ritmo, su propio instrumento, su propio aire y su propio estilo único.

En los Andes, las melodías están marcadas por el sonido de la zampoña, el charango y la kena. Originalmente sin palabras, las melodías melancólicas pronto fueron acompañadas por textos trágicos y melodramáticos para las necesidades del mercado de masas.

ALTA EXPRESIÓN es un programa que se emite desde La Paz – Bolivia mediante chukutaradio.com en señal digital para el mundo, en conexión con medios de comunicación que bajan y emiten en señal abierta como radio Maya 100.9 F.M. en Buenos Aires Argentina y Radio América en Chulumani – Yungas. En el transcurso del tiempo, se suman más medios dentro y fuera del país.

ALTA EXPRESIÓN, sus características principales:`,
  features: [
    'Contenido musical variado:\n- Géneros tradicionales como cueca, morenada, tinku, saya, caporal, etc.\n- Música folklórica contemporánea.\n- Fusión o música andina moderna.',
    'Segmentos temáticos:\n- Espacios dedicados a regiones.\n- Especiales por artistas o agrupaciones destacadas.',
    'Información cultural:\n- Origen de géneros y danzas.\n- Entrevistas a músicos, compositores o gestores culturales.\n- Contexto histórico o social de las canciones.',
    'Participación del público:\n- Llamadas en vivo o mensajes para pedir canciones.\n- Opiniones o recuerdos relacionados con la música boliviana.',
    'Promoción de eventos:\n- Anuncios de festivales y eventos culturales.\n- Cobertura de actividades culturales y musicales.',
    'Educativo y de rescate cultural:\n- Difusión de música poco conocida o en riesgo de olvido.\n- Uso de lenguas originarias como quechua, aymara o guaraní.',
    'Locución y ambientación:\n- Locutores con conocimiento del folklore boliviano.\n- Uso de expresiones y acentos regionales.',
  ],
  },
];

const truncate = (text, maxLength = 60) =>
  text.length > maxLength ? text.slice(0, maxLength) + '...' : text;

const ProgramCards = () => {
  const [open, setOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);

  const handleOpen = (program) => {
    setSelectedProgram(program);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProgram(null);
  };

  return (
    <Box
      sx={{
        backgroundColor: '#15A67D',
        borderRadius: '24px',
        border: '2px solid #15A67D',
        py: 8,
        px: { xs: 2, sm: 4, md: 6 },
        mx: 'auto',
        maxWidth: '1200px',
      }}
    >
      <Typography variant="h4" textAlign="center" fontWeight="bold" color="white" mb={4}>
        Nuestros Programas
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 4, md: 2 },
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        {programs.map((program, index) => (
          <Card
            key={index}
            onClick={() => handleOpen(program)}
            sx={{
              width: { xs: '100%', sm: 280, md: 300 },
              mx: 'auto',
              minHeight: 400,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '20px',
              overflow: 'hidden',
              backgroundColor: '#ffffff',
              textAlign: 'center',
              boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
              },
            }}
          >
            <CardMedia
              component="img"
              image={program.image}
              alt={program.title}
              sx={{
                borderRadius: '50%',
                width: 150,
                height: 150,
                mt: 5,
                mx: 'auto',
              }}
            />
            <CardContent
              sx={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                px: 2,
                textAlign: 'center',
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                {program.title}
              </Typography>
              <br />
              <Typography variant="body2" color="text.secondary">
                {truncate(program.description, 60)}
              </Typography>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation(); // evita que se active también el click del Card
                  handleOpen(program);
                }}
                sx={{ mt: 2 }}
              >
                Ver más
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: 320, md: 500 },
            maxHeight: '80vh',
            overflowY: 'auto',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
            outline: 'none',
            border: 'none',
          }}
        >
          {selectedProgram && (
            <>
              <CardMedia
                component="img"
                image={selectedProgram.image}
                alt={selectedProgram.title}
                sx={{
                  borderRadius: '50%',
                  width: 120,
                  height: 120,
                  mx: 'auto',
                  mb: 2,
                }}
              />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                {selectedProgram.title}
              </Typography>

              <Box sx={{ textAlign: 'left', whiteSpace: 'pre-line', mt: 2 }}>
                <Typography variant="body1" color="text.secondary" paragraph>
                  {selectedProgram.description}
                </Typography>

                {selectedProgram.features && (
                  <>
                    <Typography variant="body1" fontWeight="bold" mt={2}>
                      Algunas de sus características principales son:
                    </Typography>
                    <ul style={{ paddingLeft: '20px' }}>
                      {selectedProgram.features.map((item, idx) => (
                        <li key={idx} style={{ marginBottom: '8px' }}>
                          <Typography variant="body2" color="text.secondary">{item}</Typography>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </Box>

              <Box mt={3} textAlign="center">
                <Button onClick={handleClose} variant="contained" color="primary">
                  CERRAR
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default ProgramCards;
